export enum TipoMarketplace {
    "PDV" = "PDV",
    "IFOOD" = "IFOOD",
    "RAPPI" = "RAPPI",
    "WHATSAPP" = "WHATSAPP",
    "CARDAPIO_DIGITAL_SIMPLES" = "CARDAPIO_DIGITAL_SIMPLES",
    "CARDAPIO_DIGITAL_MESA" = "CARDAPIO_DIGITAL_MESA",
    "CARDAPIO_DIGITAL_DELIVERY_RETIRADA" = "CARDAPIO_DIGITAL_DELIVERY_RETIRADA"
}

export enum TipoMarketplaceTitulo {
    "PDV" = "Ponto de venda (PDV)",
    "IFOOD" = "IFood",
    "RAPPI" = "Rappi",
    "WHATSAPP" = "WhatsApp",
    "CARDAPIO_DIGITAL_SIMPLES" = "Simples",
    "CARDAPIO_DIGITAL_MESA" = "QR Code",
    "CARDAPIO_DIGITAL_DELIVERY_RETIRADA" = "Cardápio Online"
}

export enum TipoMarketplaceDescricao {
    "PDV" = "Sistema utilizado internamente pelos colaboradores para emitir pedidos",
    "IFOOD" = "Integração com a plataforma iFood.",
    "RAPPI" = "Integração com a plataforma Rappi.",
    "WHATSAPP" = "Integração com o WhatsApp.",
    "CARDAPIO_DIGITAL_SIMPLES" = "Cardápio digital sem funcionalidade de pedidos.",
    "CARDAPIO_DIGITAL_MESA" = "Cardápio digital com sessões por mesa para pedidos sem garçom.",
    "CARDAPIO_DIGITAL_DELIVERY_RETIRADA" = "Cardápio digital para pedidos online com opção de entrega e retirada."
}

export enum TipoMarketplaceCor {
    "PDV" = "#000080",
    "IFOOD" = "#EA1D2C",
    "WHATSAPP" = "#109010",
    "RAPPI" = "#FF4B55",
    "CARDAPIO_DIGITAL_SIMPLES" = "#4CAF50",
    "CARDAPIO_DIGITAL_MESA" = "#6A0DAD",
    "CARDAPIO_DIGITAL_DELIVERY_RETIRADA" = "#1976D2"
}

export enum TipoMarketplaceSigla {
    "PDV" = "PDV",
    "IFOOD" = "iFood",
    "RAPPI" = "Rappi",
    "WHATSAPP" = "Whats",
    "CARDAPIO_DIGITAL_SIMPLES" = "CDS",
    "CARDAPIO_DIGITAL_MESA" = "CDM",
    "CARDAPIO_DIGITAL_DELIVERY_RETIRADA" = "CDO"
}

export const tiposMarketplaceEmBreve = [
    TipoMarketplace.RAPPI,
    TipoMarketplace.CARDAPIO_DIGITAL_SIMPLES,
];

/**
 * Funcionalidade do perfil (plano) que libera o QR Code por mesa. Segue a mesma regra do
 * iFood: só quem contratou o plano com a integração iFood pode criar o marketplace de mesa.
 */
export const FUNCIONALIDADE_MARKETPLACE_QRCODE_MESA = "Marketplace iFood";

export const tiposMarketplaceOcultarStatus = [
    TipoMarketplace.IFOOD,
    TipoMarketplace.RAPPI,
    TipoMarketplace.WHATSAPP,
];

export const tiposMarketplaceIndisponivel = [
    TipoMarketplace.PDV
];